import React from 'react'
import './preloader.css'
const Preloader = () => {
  return (
    <div id="js-loading" className="js-loading" >
      <div className="loading-inner">
      {/* preloader */}
        <div className="dots">
          <div>
            <div className="🤚">
              <div className="👉"></div>
              <div className="👉"></div>
              <div className="👉"></div>
              <div className="👉"></div>
              <div className="🌴"></div>
              <div className="👍"></div>
            </div>
          </div>
        </div>
      </div>
      
    </div >
  )
}

export default Preloader
